module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921071151_T.909748b4.jpg";